<template>
  <div class="box">
  <el-drawer :visible="selectvisible" width="100%" direction="btt" :with-header="false" :before-close="handleClose">
    <el-tabs tab-position="left">
      <el-tab-pane v-for="(item, index) in productsLists.conditons" :key="index" class="tabItem">
        <span slot="label">
          <el-checkbox @change="checkFirst(item)" v-model="item.choose" v-if="isHome">{{ item.title }}</el-checkbox>
          <span v-else>{{ item.title }}</span>
        </span>
        <el-collapse v-model="activeNames" @change="handleChange" accordion>
          <el-collapse-item :name="kk" v-for="(ii, kk) in item.children" :key="kk">
            <template slot="title">
              <el-checkbox @change="checkSecond(ii)" v-model="ii.choose" v-if="isHome">{{ ii.title }}</el-checkbox>
              <span v-else>{{ ii.title }}</span>
            </template>
            <div v-if="isHome">
              <el-checkbox @change="checkThird(item, ii, i)" v-model="i.choose" v-for="(i, k) in ii.children" :key="k">{{ i.title }}</el-checkbox>
            </div>
            <div v-else @click.stop>
              <el-radio v-model="typeThird" :label="i.title" v-for="(i, k) in ii.children" :key="k" @change="(e) => checkThird(item, ii, i)">{{
                i.title
              }}</el-radio>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
    </el-tabs>
    <div class="bottom"><div class="btn" @click="submit">确定</div></div>
  </el-drawer>
  </div>
</template>

<script>
import { screenList } from '../../../Json/screenList.js';
import { screenListEn } from '../../../Json/screenListEn.js';

export default {
  name: '',
  data() {
    return {
      msg: this.selectvisible,
      checkboxVisible: this.isHome,
      productsLists: null,
      activeNames: [0],
      // todo:把type进行一个判断，筛选一级，二级还是只有三级的数据
      type: null,
      typeThird: '',
      message: '',
    };
  },
  props: ['selectvisible', 'isHome'],
  created() {
    const language = localStorage.getItem('lang');
    this.$i18n.locale = language == 'en' ? language : 'zh';
    if (language == 'en') {
      this.productsLists = screenListEn;
    } else {
      this.productsLists = screenList;
      localStorage.setItem('lang', 'zh');
    }
  },
  methods: {
    // 一级菜单选择函数
    checkFirst() {},
    // 二级菜单选择函数
    checkSecond() {},
    // 三级菜单选择函数
    checkThird(first, second, third) {
      this.type = '';
      this.type = first.title + '-' + second.title + '-' + third.title;
      this.message = third.type;
    },
    handleChange() {},
    submit() {
      this.$emit('funType', this.type);
      this.$emit('funMessage', this.message);
      this.msg = false;
      this.$emit('fun', this.msg);
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      //   .then((_) => {
      //     done();
      //   })
      //   .catch((_) => {});
        done();
    },
  },
};
</script>

<style scoped lang="scss">
.el-dialog {
  text-align: center;
}
.bottom {
  width: 100%;
  height: 10%;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(109, 109, 109, 0.35);
  position: relative;
  padding-right: 6.4vw;
  box-sizing: border-box;
  .btn {
    width: 24vw;
    height: 9.6vw;
    background: #006fb8;
    border-radius: 1vw;
    line-height: 9.6vw;
    text-align: center;
    font-size: 4.2vw;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    float: right;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
<style scoped>
.el-dialog__wrapper >>> .el-dialog__footer {
  text-align: center;
}
.dialog-footer >>> .el-button--primary {
  width: 28.8vw;
  height: 9.6vw;
  background: #006fb8;
  border-radius: 1vw;
}
.el-dialog__wrapper >>> .el-dialog {
  width: 66.67vw !important;
  /* height: 75.47vw; */
  background: #ffffff;
}
>>> .el-dialog__headerbtn {
  color: #312c2b;
  font-size: 2.93vw;
}
</style>
<style scoped>
.el-drawer__wrapper >>> .el-drawer {
  height: 60% !important;
}
.el-drawer__wrapper >>> .el-drawer__body {
  height: 80%;
}
.el-tabs--left >>> .el-tabs__item.is-left {
  text-align: left;
  padding: 0;
  box-sizing: border-box;
  height: 8vw;
  line-height: 4vw;
  font-size: 3.2vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  width: 25.6vw;
  /* overflow: hidden; */
  word-break: break-all;
  white-space: normal;
  word-wrap: break-word;
  margin-top: 3vw;

  /* overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; */
}
/* .el-drawer__wrapper >>> span {
  width: 100%;
  white-space: normal;
} */
.el-tabs >>> .el-tabs__header {
  width: 39.2%;
  padding: 5.3vw 0 5.3vw 4vw;
  box-sizing: border-box;
  margin: 0;
}
.el-tabs >>> .el-tabs__content {
  padding-top: 5.3vw;
  padding-bottom: 5.3vw;
  box-sizing: border-box;
}
.el-tabs {
  height: 90%;
}
.el-drawer__wrapper >>> .el-tabs__active-bar {
  background-color: transparent !important;
}
.el-collapse {
  border-top: 0px;
}
.el-checkbox >>> .el-checkbox__label {
  white-space: normal;
  vertical-align: text-top;
}
.el-radio >>> .el-radio__label {
  white-space: normal;
  vertical-align: text-top;
  display: inline-block;
  padding-left: 1.3vw;
  font-size: 3.2vw;
  /* overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; */
}
.el-collapse-item >>> .el-collapse-item__wrap {
  background: #f6f6f7;
  max-height: 81vw;
  overflow-y: auto;
}
.el-collapse-item >>> .el-checkbox,
.el-radio {
  height: 8vw;
  line-height: 4vw;
  font-size: 3.2vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 2vw;
  display: block;
}
.el-collapse-item >>> .el-collapse-item__content {
  padding-bottom: 0px;
  padding: 0px 4vw;
  box-sizing: border-box;
  width: 100%;
}
.el-collapse-item >>> .el-collapse-item__header {
  padding: 0px 4vw;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.el-collapse-item >>> .el-collapse-item__header span {
  /* width: 51.2vw; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
